// extracted by mini-css-extract-plugin
module.exports = {"ExtraInfo":"ExtraInfo_ExtraInfo__3UYYT"};